export default class FiltroPedidosAguaAprovacao {
    constructor() {
        this.UnidadeId = undefined;
        this.ClienteId = undefined;
        this.RepresentanteId = undefined;
        this.NumeroSolicitacao = undefined;
        this.NumeroPedido = undefined;
        this.TipoPedido = undefined;
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.DataEntregaInicio = undefined;
        this.DataEntregaTermino = undefined;
        this.DadosClienteAgrupador = undefined;
        this.ComponentesExpandidos = undefined;
        this.Status = undefined;
        this.StatusPedidoParcela = undefined;
        this.DadosClienteAgrupador = undefined;
    }
}